// extracted by mini-css-extract-plugin
export var productImage = "_lr-1";
export var viewLink = "_lr-2";
export var wishlistItem = "_lr-0";